import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Report } from 'src/app/models/report.model';
import { User } from 'src/app/models/user.model';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { DealersService } from 'src/app/services/dealers.service';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { plaintext } from "../../../assets/plaintext";

@Component({
  selector: 'app-manage-report-gmadmin',
  templateUrl: './manage-report-gmadmin.component.html',
  styleUrls: ['./manage-report-gmadmin.component.scss']
})
export class ManageReportGmadminComponent implements OnInit {
  clickstreamPageTitle = 'Manage Security';
  user: User;
  plaintext = plaintext;

  report: Report;
  changeMade = false;

  isLoading = true;
  isSecurityLoading = false;
  isIconLoading = false;

  grantAccessLoading = false;
  removeAccessLoading = false;

  constructor(private reportService: ReportsService, private dealersService: DealersService, private userService: UserService, public dialog: MatDialog,
    private router: Router, private route: ActivatedRoute, private _snackBar: MatSnackBar, private clickstream: ClickStreamService) {
    this.user = this.userService.user;
  }

  ngOnInit(): void {
    if (this.user.businessFunction != 'dealeradmin') this.router.navigate(['/reports']);

    this.report = this.reportService.reportState; // attempt to get it from the state first

    if (!this.report) {
      var reportId = this.route.snapshot.paramMap.get('id');
      this.reportService.getReport(reportId).subscribe(reportData => {
        this.report = reportData.state;
        if (this.report.reportOwner) this.report.reportOwnerQuery = this.report.reportOwner.email;
        if (this.report.businessOwner) this.report.businessOwnerQuery = this.report.businessOwner.email;
        if (this.report.operationsOwner) this.report.operationsOwnerQuery = this.report.operationsOwner.email;
        if (this.report.innovationOwner) this.report.innovationOwnerQuery = this.report.innovationOwner.email;
        this.isLoading = false;
        this.fetchSecurity();
      })
    } else {
      this.isLoading = false;
      this.fetchSecurity();
    }
  }

  fetchSecurity(): void {
    this.isSecurityLoading = true;
    this.reportService.getReportSecurity(this.report.guid).subscribe(res => {
      console.log('res', res);
      this.isSecurityLoading = false;
      this.report.countries = res;
    });
  }

  @ViewChild('file') file;
  public files: Set<File> = new Set();
  uploading = false;
  uploadSuccessful = false;
  addFile() {
    this.file.nativeElement.click();
  }

  handleFileUpload(): void {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    this.isIconLoading = true;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        this.reportService.uploadReportIcon(files[key], this.report.guid).subscribe(result => {
          this.report.iconBase64 = result.iconBase64;
          this.report.iconFileExtension = result.fileExtension;
          this.isIconLoading = false;
          this.changeMade = true;
        })
      }
    }
  }

  setChangesMade() {
    this.changeMade = true;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.changeMade;
  }

  saveError = '';
  saveChanges() {
    console.log('saving', this.report);
    if (!this.report.asms && this.report.asms.length < 5) {
      this.saveError = 'ASMS Required';
    } else if (this.report.reportOwnerQuery != null && this.report.reportOwnerQuery.length == 0) {
      this.saveError = 'Owner required'
    } else if (!this.report.description || this.report.description.length < 40) {
      this.saveError = 'Description is required and must be more than 40 characters.'
    } else {
      this.reportService.updateReport(this.report).subscribe(newReport => {
        this.changeMade = false;
        const dialogRef = this.dialog.open(SaveConfirmedDialog);
        // this._snackBar.open('Report Updated Successfully', 'Close', { duration: 2000 });
        this.saveError = '';
        // this.router.navigate(['/reports']);
      }, error => {
        this.saveError = error.error.message;
      });
      this.clickstream.send('save', 'click', this.clickstreamPageTitle, 'Save', '', true);
    }
  }
}

@Component({
  selector: 'save-confirmed-dialog',
  templateUrl: './save-confirmed-dialog.html',
  styleUrls: ['./save-confirmed-dialog.scss']
})
export class SaveConfirmedDialog implements OnInit {

  constructor(public dialogRef: MatDialogRef<SaveConfirmedDialog>) { }

  ngOnInit() {
    this.dialogRef.updateSize("350px", "150px")
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
